import { Button, Dialog, DialogTitle, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../contexts/AppContext";

import LogoVecto from "../Welcome/Logo/LogoVecto";
import { setStyle } from "../../util";
import {PropsWithChildren} from "react";

const Layout = ({children}:PropsWithChildren) => {
    const { defaultValues } = useContext(AppContext);


    useEffect(() => {
        if (defaultValues) { setStyle(defaultValues); }
    })



    return (
        <Container className="bg2">
            <Grid container direction="row">
                <Grid className="wrapper-demie-logo"xs={12} sm={12} md={6} lg={6} xl={6}>
                    <LogoVecto />
                </Grid>
                <Grid className="wrapper-demie-contenu" xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Main className="container-contenu">
                        {children}
                    </Main>
                </Grid>
            </Grid>
        </Container>

    );
};

const Container = styled.div`
    display: flex;
    padding: 1em;
    border-radius: 5px;
`


const Main = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2em;
    align-self: center;
`

const TopSubdivision = styled.div`
    display: flex;
`

const BottomSubdivision = styled.div`
    margin: auto;
    margin-top: 1em;
`


export default Layout;